import { defineStore } from 'pinia'
import state from '@/stores/admin/state'
import actionsStore from '@/stores/admin/actions'
import gettersStore from '@/stores/admin/getters'
import mutationsStore from '@/stores/admin/mutations'

export const useAdminStore = defineStore('admin', () => {
  const getters = gettersStore(state)
  const mutations = mutationsStore(state)
  const actions = actionsStore(mutations)
  return {
    state,
    getters,
    mutations,
    actions,
  }
})
